import React from 'react';
import { Navigate } from 'react-router-dom';

const RoleRedirect = () => {
  const isLoggedIn = localStorage.getItem('logged_in') === 'true';
  const role = localStorage.getItem('user_role');

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  if (role === 'admin') {
    return <Navigate to="/admin/" replace />;
  }

  if (role === 'theatre') {
    return <Navigate to="/theater/" replace />;
  }

  if (role === 'event') {
    return <Navigate to="/event/" replace />;
  }

  // Fallback: invalid or missing role → force logout
  localStorage.clear();
  return <Navigate to="/" replace />;
};

export default RoleRedirect;